module.exports = __webpack_public_path__ + "img/DISCONNECTED.066d9c65.svg";